import React, { FC, ReactNode, memo } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { classNames } from '@dt/fe-utils'
import { Navigator } from '@cps'
import './index.scss'

// props
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 页面标题 */
  title?: string;
  /** 是否隐藏back按钮和文字 */
  hideBack?: boolean;
  /** 是否隐藏整个顶部导航header */
  hideHeader?: boolean;
  /** 页面弹窗 */
  modal?: ReactNode;
  /** 注：页面级别组件用IonContent包裹，保证页面切换动画的流畅 */
  scrollContent?: boolean;
}

const PageContainer: FC<IProps> = ({ id, className, title = '', hideBack, hideHeader, modal, scrollContent = true, children }) => {
  return (
    <IonPage className={classNames('page-container', className)} id={id}>
      <Navigator
        title={title}
        hideBack={hideBack}
        hideHeader={hideHeader}
      />
      {/* 内容 */}
      {
        scrollContent
          ? (
            <IonContent>
              {
                children
              }
            </IonContent>
          )
          : children
      }
      {/* 外层modal */}
      {
        modal
      }
    </IonPage>
  )
}

export default memo(PageContainer)
